/** Meta Form (CARI_FORM_GELIS) select helpers for satış / arama UI */

export function enrichMetaFormItems(list) {
  const rows = Array.isArray(list) ? list : [];
  return rows.map((g) => {
    const no = g.CFG_GELIS_NO ?? '';
    const tar = g.CFG_GIR_TAR
      ? new Date(g.CFG_GIR_TAR).toLocaleString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      : '';
    const camp = String(g.CFG_CAMPAIGN || '').trim();
    const formName = String(g.CFG_FORM_NAME || '').trim();
    const label =
      g.META_FORM_LABEL ||
      [`Geliş ${no}`, tar || null, formName || camp || null].filter(Boolean).join(' — ');
    return {
      ...g,
      CFG_REF: Number(g.CFG_REF ?? g.cfg_ref),
      META_FORM_LABEL: label,
    };
  });
}

/** List already sorted desc by gelis no → first item is latest */
export function latestMetaFormRef(list) {
  const rows = enrichMetaFormItems(list);
  return rows[0]?.CFG_REF ?? null;
}

/** Tek formda seçim UI gizlenir; kayıt yine o forma bağlanır. */
export function hasMultipleMetaForms(list) {
  return enrichMetaFormItems(list).length > 1;
}

/** DX SelectBox / form satırı için dikkat çekici ama standart alan rengi */
export const META_FORM_EDITOR_CLASS = 'meta-form-select';
export const META_FORM_FIELD_CLASS = 'meta-form-field';
